import { cn } from "~/utils";

export const ThemaCodesTableRowHighlightedText = ({
  text,
  fallback,
  uppercase = false,
  markClassName,
}: {
  text?: string | null;
  fallback?: string | null;
  uppercase?: boolean;
  markClassName?: string;
}) => {
  // Use highlighted text if available and contains <mark> tags, otherwise fallback
  if (!text || !text.includes("<mark>")) {
    return uppercase && fallback ? fallback.toUpperCase() : fallback;
  }

  // Split by <mark> and </mark> tags to separate highlighted and normal text
  const parts = text.split(/(<mark>.*?<\/mark>)/g);

  return (
    <>
      {parts.map((part, index) => {
        if (part.startsWith("<mark>") && part.endsWith("</mark>")) {
          const highlightedContent = part.slice(6, -7); // Remove <mark> and </mark>
          return (
            <mark
              // biome-ignore lint/suspicious/noArrayIndexKey: parts come from splitting one string and never reorder
              key={`highlight-${index}`}
              className={cn("bg-yellow-200 px-0.5 rounded-sm", markClassName)}
            >
              {uppercase
                ? highlightedContent.toUpperCase()
                : highlightedContent}
            </mark>
          );
        }
        // Return normal text
        return uppercase && part ? part.toUpperCase() : part;
      })}
    </>
  );
};
